import { FeatureLaunch, isFeatureLaunched } from '@commenda/feature-launches';
import { AffiliateFirmHelper } from '@commenda/utils';
import { useConfig } from 'context/useConfig';
import { useMemo } from 'react';

/** Who the viewer is to an affiliate firm, read from the config's organizations list (no fetch).
 * Lives in the app because `useConfig` is an app-level context that `packages/*` cannot import.
 * Callers gate every affiliate-only branch on `isFlagOn` as well, so flag-off builds render
 * exactly as before. */
export const useAffiliateViewer = () => {
  const { organizations } = useConfig();

  const membership = useMemo(
    () => AffiliateFirmHelper.getViewerMembership(organizations),
    [organizations]
  );

  return {
    membership,
    isAffiliateMember: membership !== null,
    affiliateFirmId: membership?.affiliateFirmId ?? null,
    isFlagOn: isFeatureLaunched(FeatureLaunch.A_AND_M_TP_DEMO),
  };
};
